module.exports = __webpack_public_path__ + "img/files_ressources.4faf60fa.svg";